// extracted by mini-css-extract-plugin
module.exports = {"moduleTypeTitle":"styles__moduleTypeTitle___2J49D","container":"styles__container___1AT9o"};